import {
    PickListItem
} from "../../../shared/entities/pick-list/pick-list.entities";

import {
    IEditController
} from "../../../shared/components/edit-table/edit-table";

import {
    CabHubAccessEntity,
    CabHubRoleTable,
    CabHubPermissionTable
} from "./update_access.table";

export type UpdateAccessPageVm = {
    Users:
    CabHubAccessEntity[];

    PermissionUsers:
    CabHubAccessEntity[];

    RolePickList:
    PickListItem[];

    HubPickList:
    PickListItem[];
};

declare const page: {
    roleTable:
    CabHubRoleTable;

    permissionTable:
    CabHubPermissionTable;

    roleEdit:
    CabHubRoleEditController;

    permissionEdit:
    CabHubPermissionEditController;
};


export class UpdateAccessPage {
    public roleTable:
        CabHubRoleTable;

    public permissionTable:
        CabHubPermissionTable;

    public roleEdit:
        CabHubRoleEditController;

    public permissionEdit:
        CabHubPermissionEditController;

    constructor(
        private readonly model:
            UpdateAccessPageVm
    ) {
        this.roleEdit =
            new CabHubRoleEditController(
                this.model
            );

        this.permissionEdit =
            new CabHubPermissionEditController(
                this.model
            );

        this.roleTable =
            new CabHubRoleTable(
                "cab-hub-role-table-host",
                this.model.Users ?? [],
                this.roleEdit
            );

        this.permissionTable =
            new CabHubPermissionTable(
                "cab-hub-permission-table-host",
                this.model.Users ?? [],
                this.permissionEdit,
                () =>
                    this.permissionEdit
                        .openAddPermission()
            );

        this.roleTable
            .initialize();

        this.permissionTable
            .initialize();

        this.wireTabs();
    }

    private wireTabs():
        void {

        $("#access-tabs a")
            .off(
                "shown.bs.tab.cabHubAccess"
            )
            .on(
                "shown.bs.tab.cabHubAccess",
                () => {

                    this.roleTable
                        .resize();

                    this.permissionTable
                        .resize();
                }
            );
    }
}


export class CabHubRoleEditController
    implements IEditController {

    private currentUser:
        CabHubAccessEntity;

    constructor(
        private readonly vm:
            UpdateAccessPageVm
    ) {
    }

    public getEditMenu():
        string {

        return `
            <button type="button"
                    class="dropdown-item"
                    onclick="
                        page.roleEdit
                            .editCurrentRole()
                    ">
                Edit Role and Hub
            </button>
        `;
    }

    public editCurrentRole():
        void {

        const user =
            page.roleTable
                .editTable
                .currentTargetItem as
            CabHubAccessEntity;

        if (!user) {
            return;
        }

        this.openRole(
            user
        );
    }

   
    private openRole(
        user:
            CabHubAccessEntity
    ): void {

        this.currentUser =
            user;

        const roleOptions =
            this.renderRoleOptions(
                user.Roles ?? []
            );
        const hubOptions =
            (this.vm.HubPickList ?? [])
                .map(
                    hub => `
                <option value="${hub.Id}"
                    ${user.HubId === hub.Id
                            ? "selected"
                            : ""}>
                    ${hub.Value}
                </option>
            `
                )
                .join("");

        $("#cab-hub-access-modal-title")
            .text(
                `Edit Roles - ${user.Name}`
            );

        $("#cab-hub-access-form")
            .html(`
        <div class="form-group">
            <label class="font-weight-500">
                Roles
            </label>

            ${roleOptions}
        </div>

        <div class="form-group mt-3">
            <label class="font-weight-500">
                Hub
            </label>

            <select id="cab-hub-role-hub"
                    class="selectpicker"
                    data-live-search="true"
                    data-width="100%"
                    data-size="10"
                    title="No Hub">
                <option value="">
                    No Hub
                </option>

                ${hubOptions}
            </select>
        </div>
    `);

        $("#cab-hub-role-hub")
            .selectpicker();

        this.openModal();
        this.wireSave();
    }

    private renderRoleOptions(
        selectedRoles:
            string[]
    ): string {

        return (this.vm.RolePickList ?? [])
            .map(
                role => {

                    const checked =
                        selectedRoles
                            .includes(
                                role.Value
                            )
                            ? "checked"
                            : "";

                    return `
                        <div class="form-check mb-1">
                            <input type="checkbox"
                                   class="
                                       form-check-input
                                       js-role-access
                                   "
                                   id="role-${role.Id}"
                                   value="${role.Value}"
                                   ${checked} />

                            <label class="form-check-label pl-0"
                                   for="role-${role.Id}">
                                ${role.Value}
                            </label>
                        </div>
                    `;
                }
            )
            .join("");
    }

    private wireSave():
        void {

        $("#cab-hub-save-access-button")
            .off(
                "click.cabHubAccess"
            )
            .on(
                "click.cabHubAccess",
                async () => {

                    await this.saveRole();
                }
            );
    }

    private async saveRole():
        Promise<void> {

        const userId =
            this.currentUser
                ? this.currentUser.UserId
                : Number(
                    $("#cab-hub-access-user")
                        .val()
                );

        if (!userId) {
            this.showError(
                "Select a user."
            );

            return;
        }

        const roles:
            string[] = [];

        $(".js-role-access:checked")
            .each(
                function () {

                    roles.push(
                        String(
                            $(this).val()
                        )
                    );
                }
            );

        const user =
            this.currentUser ??
            this.vm.Users
                .find(
                    item =>
                        item.UserId ===
                        userId
            );
      
        const previousRoles =
            user?.Roles ?? [];

        const addedRoles =
            roles.filter(
                role =>
                    !previousRoles.includes(
                        role
                    )
            );

        const removedRoles =
            previousRoles.filter(
                role =>
                    !roles.includes(
                        role
                    )
            );
        const previousHubId =
            user?.HubId ?? null;

        const previousHubDisplay =
            user?.HubDisplay ?? "";

        const hubValue =
            $("#cab-hub-role-hub")
                .val();

        const hubId =
            hubValue
                ? Number(
                    hubValue
                )
                : null;

        try {
            const result: any = await $.ajax({
                url:
                    window.location.pathname +
                    "?handler=UpdateRole",

                method:
                    "POST",

                contentType:
                    "application/json",

                headers: {
                    "RequestVerificationToken":
                        $(
                            'input[name="__RequestVerificationToken"]'
                        ).val() as string
                },

                data:
                    JSON.stringify({
                        UserId:
                            userId,

                        Roles:
                            roles,

                        HubId:
                            hubId
                    })
            });

            if (user) {
                user.Roles =
                    roles;

                user.RoleDisplay =
                    roles.join(
                        ", "
                    );

                user.HubId =
                    result.hubId ?? null;

                user.HubDisplay =
                    result.hubName ?? "";
            }

            page.roleTable
                .refresh();

            let message =
                "Access updated.";

            if (addedRoles.length > 0) {
                message +=
                    ` Roles added: ${addedRoles.join(", ")}.`;
            }

            if (removedRoles.length > 0) {
                message +=
                    ` Roles removed: ${removedRoles.join(", ")}.`;
            }

            if (
                previousHubId !==
                (result.hubId ?? null)
            ) {
                if (result.hubId) {
                    message +=
                        ` Hub changed from ` +
                        `${previousHubDisplay || "None"} ` +
                        `to ${result.hubName}.`;
                }
                else {
                    message +=
                        ` Hub removed: ` +
                        `${previousHubDisplay || "None"}.`;
                }
            }

            this.showChange(
                message
            );
        }
        catch (error) {
            console.error(
                error
            );

            this.showError(
                "Access could not be saved."
            );
        }
    }

    private openModal():
        void {

        this.resetModal();

        $("#cab-hub-access-modal")
            .modal(
                "show"
            );
    }

    private resetModal():
        void {

        $("#cab-hub-access-error")
            .empty()
            .addClass(
                "d-none"
            );

        $("#cab-hub-access-change")
            .empty()
            .addClass(
                "d-none"
            );

        $("#cab-hub-access-form")
            .removeClass(
                "d-none"
            );

        $("#cab-hub-save-access-button")
            .removeClass(
                "d-none"
            );
    }

    private showChange(
        message:
            string
    ): void {

        $("#cab-hub-access-form")
            .addClass(
                "d-none"
            );

        $("#cab-hub-save-access-button")
            .addClass(
                "d-none"
            );

        $("#cab-hub-access-change")
            .text(
                message
            )
            .removeClass(
                "d-none"
            );
    }

    private showError(
        message:
            string
    ): void {

        $("#cab-hub-access-error")
            .text(
                message
            )
            .removeClass(
                "d-none"
            );
    }

    public async saveItems(
        items: any[],
        isAdd: boolean
    ): Promise<void> {

        return;
    }
}


export class CabHubPermissionEditController
    implements IEditController {

    private currentUser:
        CabHubAccessEntity;

    constructor(
        private readonly vm:
            UpdateAccessPageVm
    ) {
    }

    public getEditMenu():
        string {

        return `
            <button type="button"
                    class="dropdown-item"
                    onclick="
                        page.permissionEdit
                            .editCurrentPermission()
                    ">
                Edit Permission
            </button>
        `;
    }

    public editCurrentPermission():
        void {

        const user =
            page.permissionTable
                .editTable
                .currentTargetItem as
            CabHubAccessEntity;

        if (!user) {
            return;
        }

        this.openPermission(
            user
        );
    }

    public openAddPermission():
        void {

        this.currentUser =
            null;

        const userOptions =
            (this.vm.Users ?? [])
                .filter(
                    user =>
                        user.HubId != null &&
                        !user.HasHubPermission
                )
                .sort(
                    (a, b) =>
                        a.Name.localeCompare(
                            b.Name
                        )
                )
                .map(
                    user => `
                <option value="${user.UserId}">
                    ${user.Name} (${user.Email})
                </option>
            `
                )
                .join("");

        $("#cab-hub-access-modal-title")
            .text(
                "Add Hub Permission"
            );

        $("#cab-hub-access-form")
            .html(`
        <div class="form-group font-weight-700">
            <label>
                User
            </label>

            <select id="cab-hub-access-user"
                    class="selectpicker"
                    data-live-search="true"
                    data-width="100%"
                    data-size="10"
                    title="Select User">

                ${userOptions}

            </select>
        </div>

      <div class="cab-hub-access-section">
    <div class="section-label">
        Hub Survey Access
    </div>

    <div class="font-size12 text-muted mb-3">
        This permission allows the selected Hub user to view
        completed survey responses for their assigned Hub.
        Their Hub association is determined by their existing
        portal profile.
    </div>

    <div class="form-check ">
        <input type="checkbox"
               id="view-completed-hub-surveys"
               class="form-check-input"
               checked />

        <label class="form-check-label font-size14 pl-0"
               for="view-completed-hub-surveys">
            View Completed Hub Surveys
        </label>
    </div>
</div>
    `);

        $("#cab-hub-access-user")
            .selectpicker();

        this.openModal();
        this.wireSave();
    }

    private openPermission(
        user:
            CabHubAccessEntity
    ): void {

        this.currentUser =
            user;

        $("#cab-hub-access-modal-title")
            .text(
                `Edit Permission - ${user.Name}`
            );

        $("#cab-hub-access-form")
            .html(`
 
                <div class="form-group">
                    <div class="form-check">

                        <input type="checkbox"
                               id="view-completed-hub-surveys"
                               class="form-check-input"
                               ${user.HasHubPermission
                    ? "checked"
                    : ""
                } />

                        <label class="form-check-label"
                               for="view-completed-hub-surveys">
                            View Completed Hub Surveys
                        </label>

                    </div>
                </div>
            `);

        this.openModal();
        this.wireSave();
    }

    private wireSave():
        void {

        $("#cab-hub-save-access-button")
            .off(
                "click.cabHubAccess"
            )
            .on(
                "click.cabHubAccess",
                async () => {

                    await this.savePermission();
                }
            );
    }

    private async savePermission():
        Promise<void> {

        const userId =
            this.currentUser
                ? this.currentUser.UserId
                : Number(
                    $("#cab-hub-access-user")
                        .val()
                );

        if (!userId) {
            this.showError(
                "Select a user."
            );

            return;
        }

        const user =
            this.vm.Users
                .find(
                    item =>
                        item.UserId ===
                        userId
            );

        if (!user) {
            this.showError(
                "The selected user could not be found."
            );

            return;
        }
        const isAdd =
            this.currentUser == null;

        const hasPermission =
            $("#view-completed-hub-surveys")
                .is(
                    ":checked"
            );
  

        if (
            isAdd &&
            !hasPermission
        ) {
            this.showError(
                "Select the permission before saving."
            );

            return;
        }

        try {
            const result: any =
                await $.ajax ({
                url:
                    window.location.pathname +
                    "?handler=UpdatePermission",

                method:
                    "POST",

                contentType:
                    "application/json",

                headers: {
                    "RequestVerificationToken":
                        $(
                            'input[name="__RequestVerificationToken"]'
                        ).val() as string
                },

                data:
                    JSON.stringify({
                        UserId:
                            userId,

                        HasPermission:
                            hasPermission
                    })
            });

            user.HasHubPermission =
                hasPermission;

            user.HubAccessDisplay =
                hasPermission
                    ? result.hubName ?? user.HubDisplay
                    : "";

            page.permissionTable
                .refresh();
            $("#cab-hub-access-modal")
                .modal(
                    "hide"
                );
        }
        catch (error) {
            console.error(
                error
            );

            this.showError(
                "Permissions could not be saved."
            );
        }
    }

    private openModal():
        void {

        this.resetModal();

        $("#cab-hub-access-modal")
            .modal(
                "show"
            );
    }

    private resetModal():
        void {

        $("#cab-hub-access-error")
            .empty()
            .addClass(
                "d-none"
            );

        $("#cab-hub-access-change")
            .empty()
            .addClass(
                "d-none"
            );

        $("#cab-hub-access-form")
            .removeClass(
                "d-none"
            );

        $("#cab-hub-save-access-button")
            .removeClass(
                "d-none"
            );
    }

    private showChange(
        message:
            string
    ): void {

        $("#cab-hub-access-form")
            .addClass(
                "d-none"
            );

        $("#cab-hub-save-access-button")
            .addClass(
                "d-none"
            );

        $("#cab-hub-access-change")
            .text(
                message
            )
            .removeClass(
                "d-none"
            );
    }

    private showError(
        message:
            string
    ): void {

        $("#cab-hub-access-error")
            .text(
                message
            )
            .removeClass(
                "d-none"
            );
    }

    public async saveItems(
        items: any[],
        isAdd: boolean
    ): Promise<void> {

        return;
    }
}